import { GetterTree } from "vuex";
import { IPropertyEditState } from "./property-states.store";
import { IPropertyCreativeObject } from "../../../models/property";


const getters: GetterTree<IPropertyEditState, any> = <GetterTree<IPropertyEditState, any>>{
    service: (state: IPropertyEditState) => state.service,
	projectServices: (state: IPropertyEditState) => state.projectService,
    property: (state: IPropertyEditState) => {
        return state.property;
    },
	project: (state: IPropertyEditState) => {
		return state.property;
	},
    originalProperty: (state: IPropertyEditState) => {
        return state.originalProperty;
    },
	originalProject: (state: IPropertyEditState) => {
		return state.originalProperty;
	},
    propertyCreativeObject: (state: IPropertyEditState): IPropertyCreativeObject => {
        return state.creativeObject;
    },
    
    previouseStreetLookupKey: (state: IPropertyEditState): string => {
        return state['previouseStreetLookupKey'];
    },
   
    propertySubcategory: (state: IPropertyEditState) => {
        return state.propertySubCategory;
    },
    propertyDescription: (state: IPropertyEditState) => {
        return state.propertyDescription;
    },
    isListingLoading: (state) => state.loadingList,
    isDetailLoading: (state) => state.loadingDetail,
    summaryCounterSearchProperty: (state) => state.summaryCounterSearchProperty,
    initHeritageCodes: (state) => state.initHeritages,

    getMediaPublicPlans: (state) => state.MediaPubPlans,
    // True when the property has portal pub-plan rows in the DB — live, or latched
    // before a pending type change wiped the live flag.
    hasPersistedPortalPlans: (state: IPropertyEditState) =>
        !!state.hadSelectedPortalBeforeTypeChange ||
        !!(state.property && state.property.HasSelectedPortal),
    // Raw latch value, for the tab form-cache round-trip (cache the latch itself,
    // not the OR-derived hasPersistedPortalPlans).
    hadSelectedPortalBeforeTypeChange: (state: IPropertyEditState) =>
        !!state.hadSelectedPortalBeforeTypeChange,
    isSaving: (state: IPropertyEditState) => state.isSaving,
}

export default getters;